const CompanyData = {
  logoList: [
    // {
    //   imageUrl2: "ININ_logo.png",
    //   title: "ININ Games",
    //   sort: "いにんげーむす",
    // },
    {
      imageUrl2: "Columbuscircle_logo.png",
      title: "コロンバスサークル",
      sort: "ころんばすさーくる",
    },
    {
      imageUrl2: "success_logo.png",
      title: "サクセス",
      sort: "さくせす",
    },
    // {
    //   imageUrl2: "ssj_logo.png",
    //   title: "シルバースタージャパン",
    //   sort: "しるばーすたーじゃぱん",
    // },
    {
      imageUrl2: "Beep_Logo.png",
      title: "BEEP",
      sort: "びーぷ",
    },
    // {
    //   imageUrl2: "Phoenixx_logo.png",
    //   title: "Phoenixx",
    //   sort: "ふぃーにっくす",
    // },
    {
      imageUrl2: "mebius_logo.png",
      title: "メビウス",
      sort: "めびうす",
    },
    {
      imageUrl2: "RE_logo.png",
      title: "ロケットエンジン",
      sort: "ろけっとえんじん",
    },
    // {
    //   imageUrl2: "APOLLOSOFT_LOGO.png",
    //   title: "アポロソフト",
    //   sort: "あぽろそふと",
    // },
    // {
    //   imageUrl2: "petidepot_logo.png",
    //   title: "プチデポット",
    //   sort: "ぷちでぽっと",
    // },
    // {
    //   imageUrl2: "kemco_logo.png",
    //   title: "ケムコ",
    //   sort: "けむこ",
    // },

    // {
    //   imageUrl2: "busirodo_logo.png",
    //   title: "ブシロードゲームズ",
    //   sort: "ぶしろーど",
    // },
    {
      imageUrl2: "RS34_Logo_2026.jpg",
      title: "RS34",
      sort: "あーるえす",
    },

    // {
    //   imageUrl2: "OperaHouseLogo.png",
    //   title: "オペラハウス",
    //   sort: "おぺらはうす",
    // },
    // {
    //   imageUrl2: "shanonLogo.png",
    //   title: "シャノン",
    //   sort: "しゃのん",
    // },
    // {
    //   imageUrl2: "ThousandGames_logo.png",
    //   title: "サウザンドゲームズ",
    //   sort: "さうざんどげーむず",
    // },
    // {
    //   imageUrl2: "daisyworld_logo.png",
    //   title: "デイジーワールド",
    //   sort: "でいじーわーるど",
    // },
    {
      imageUrl2: "kimaira_logo.png",
      title: "キマイラ機関",
      sort: "きまいらきかん",
    },
    {
      imageUrl2: "cosmomachia_logo.png",
      title: "コスモマキアー",
      sort: "こすもまきあー",
    },
    {
      imageUrl2: "pixel_logo.png",
      title: "PIXEL",
      sort: "ぴくせる",
    },
    {
      imageUrl2: "COSEN_logo.png",
      title: "COSEN",
      sort: "こせん",
    },
    {
      imageUrl2: "cityconnection_logo.png",
      title: "シティコネクション",
      sort: "してぃこねくしょん",
    },
  ],

  cardList: [
    // {
    //   imageUrl1: "Apollosoft.jpg",
    //   title: "アポロソフト",
    //   linkUrl1: "https://www.apollosoft.co.jp/",
    //   linkUrl2: "https://apollosoft.wixsite.com/pinbollua",
    //   text:
    //     "岐阜でゲーム開発をしております。アポロソフトと申します！<br/>今回メビウス様のイベントに参加させて頂くことになりました。<br/>「ピンボルアの勇者」はお子様でも遊んで頂ける、ＲＰＧ風ピンボールゲームです！<br/>ぜひプレイしてみてください！",
    //   gametitle: "ピンボルアの勇者",
    //   copyright: "©2020 POWE UNIT / APOLLOSOFT.",
    // },

    // {
    //   imageUrl1: "ININ2.jpg",
    //   title: "ININ Games",
    //   linkUrl1: "https://iningames.jp/",
    //   linkUrl2: "https://iningames.jp/games/air-twister/",
    //   text:
    //     "『Air Twister』は数々の革新的なゲームを世に送り出してきたゲームクリエーター鈴木裕氏が率いる「YS NET」開発の最新作3Dレールシューティングゲームです。SFファンタジーを思わせる世界観と「Valensia」の壮大なサウンドを体験しましょう！",
    //   gametitle: "Air Twister",
    //   copyright: "© 2023 YS NET. Published by United Games Entertainment.",
    // },
    // {
    //   imageUrl1: "ININ.jpg",
    //   title: "ININ Games",
    //   linkUrl1: "https://iningames.jp/",
    //   linkUrl2: "https://iningames.jp/games/rainbow-cotton/",
    //   text:
    //     "ドイツのゲームパブリッシャーININです。2000年にドリキャスで発売された魔法少女コットンの本格3Dシューティング『レインボーコットン』。当時の可愛さはまるっとそのまま、最新プラットフォーム向けて今年4月にリリースします！",
    //   gametitle: "レインボーコットン",
    //   copyright:
    //     "©2024 SUCCESS. All Rights Reserved. Published by United Games Entertainment GmbH.",
    // },

    {
      imageUrl1: "Columbuscircle.jpg",
      title: "コロンバスサークル",
      linkUrl1: "https://www.columbuscircle.co.jp/",
      //linkUrl2: "https://cosen-net.com/kanzentai/",
      text:
        "レトロゲーム互換機・新作ゲームカセット、他レトロゲーム関連商品の製造・発売でおなじみの「コロンバスサークル」です！<br>【新製品】Switch2本体・Switch本体用筐体型アーケードコントローラ「アケつく」の展示や、前回もご好評頂きましたアウトレット品の販売を行います！",
      gametitle: "物販",
    },
    {
      imageUrl1: "success.jpg",
      title: "サクセス",
      linkUrl1: "https://www.success-corp.co.jp/",
      //linkUrl2:"https://heavenseeker.success-corp.co.jp/?_gl=1*xr4py3*_gcl_au*MTA0NzIwNDE0OS4xNzAwNDUxNDIz*_ga*MjEyODk1NTkwNS4xNjkyMTYyODc4*_ga_66XH9XF0R9*MTcwNjc2NTY3Ni4xNzUuMC4xNzA2NzY1Njc2LjAuMC4w&_ga=2.142293426.1633364685.1706765677-2128955905.1692162878",
      text:
        "「サイヴァリア」シリーズ25周年ナンバリング最新作が遂に登場！君はもうBUZZったか！？<br>シューティングゲームファンが待ち望んだ「サイヴァリア」シリーズが復活！<br>シリーズの代名詞である「BUZZ」システムを継承！<br>敵の弾をかすらせるギリギリの攻防で自機が成長し、ショットなども変化！<br>爽快かつ刺激的な弾幕シューティングを体験せよ！",
      gametitle: "サイヴァリア3",
      copyright: "©SUCCESS",
    },
    {
      imageUrl1: "COSEN.jpg",
      title: "COSEN",
      //linkUrl1: "https://www.success-corp.co.jp/",
      linkUrl2:"https://cosen-net.com/candyrangers/",
    text:"色が力に！新感覚オンレール・シューティング！<br>4人のキャラクターを同時操作する全く新しいオンレール・シューティングで、時間との戦いを繰り広げましょう！<br>キャンディ、ミント、レモン、プラムの4人は、平和な街の自然環境を脅かすモンスターと戦う「キャンディレンジャー」として活躍中！<br>さあ、4人の今日のミッションは！？<br>PS5パッケージ通常版・限定版、PS5・PS4・NintendoSwitchダウンロード版 2026年2月26日に同時発売です。",
      gametitle: "キャンディレンジャー",
     // copyright: "©SUCCESS",
    },
    {
      imageUrl1: "pixel.jpg",
      title: "PIXEL",
      //linkUrl1: "https://www.success-corp.co.jp/",
      linkUrl2:"https://bountysisters.com/",
      text:
        "12月18日発売予定のバウンティシスターズをプレイアブル出展！<br>キャラクターたちやサウンド、ゲームの歴史を支えてきたクリエイターの共演をお楽しみください！",
      gametitle: "バウンティシスターズ",
    //  copyright: "©SUCCESS",
    },
    // {
    //   imageUrl1: "silverstar.jpg",
    //   title: "シルバースタージャパン",
    //   linkUrl1: "https://www.silverstar.co.jp/",
    //   linkUrl2: "https://www.silverstar.co.jp/02products/switch_spiral/",
    //   text:
    //     "将棋要素０！将棋メーカーがまじめに作ったお嬢様アクションゲームです。<br/>普段グッズなんて縁が無いので、喜んでグッズ作りました。",
    //   gametitle: "螺旋麗嬢 スパイラルお嬢様 超髪のマキナ",
    //   copyright: "©SilverStarJapan",
    // },
    {
      imageUrl1: "beep.jpg",
      title: "BEEP",
      linkUrl1: "https://www.beep-shop.com/ec/",
      //linkUrl2: "https://www.beep-shop.com/sap/radirgy2/",
      text:
        "爽快！魔女っ子シューティングの新作「コットンリブート ハイテンション！」を出展します。",
      gametitle: "コットンリブート ハイテンション！",
      //copyright: "©BEEP ©RS34,INC",
    },
    // {
    //   imageUrl1: "Phoenixx.jpg",
    //   title: "Phoenixx",
    //   linkUrl1: "https://phoenixx.ne.jp/",
    //   linkUrl2: "https://detectiveatsushi.phoenixx.ne.jp/",
    //   text:
    //     "TBSテレビ年末恒例のバラエティ番組『クイズ☆正解は一年後』の企画で誕生したアドベンチャーゲームが、Nintendo Switchに登場！年始に行われた番組収録で起こる凄惨な殺人事件の全貌を、レトロスタイルなコマンド式アドベンチャーで描き出します。",
    //   gametitle: "クイズ☆正解は一年後 presents あつしの名探偵",
    //   copyright: "©TBS ©Phoenixx Developed by Happymeal",
    // },
    {
      imageUrl1: "mebius.jpg",
      title: "メビウス",
      linkUrl1: "http://d-mebius.com/",
      linkUrl2: "http://d-mebius.com/miasmabreaker/",
      text:
        "闇夜を撃ち祓え！！<br/>ミアズマブレイカーは全方位から襲い来る大量の悪霊（ミアズマ）を 祓っていくツインスティックアクションシューティングです。",
      gametitle: "宵祓い探偵 ミアズマブレイカー",
      copyright: "©mebius.",
    },
    {
      imageUrl1: "mebius2.jpg",
      title: "メビウス",
      //linkUrl1: "http://d-mebius.com/",
      //linkUrl2: "http://d-mebius.com/steelempire/",
      text:"MSXturboRから36年、ボクたちMSXゲーマーがあの時に本当に欲しかった表現力を実装した新ビデオチップ『V9968』とZ80互換の高速新CPU『R80』を搭載した『MSX2++』がこの2026年に誕生します！<br>その新機能の一部を先取りした第一弾、シューティングゲーム『MECHANICAL BRAIN ReHash(メカニカルブレイン　リハッシュ）』がNintendo Switch™でこの春、新発売予定です。<br>『MECHANICAL BRAIN 』は、MSXturboR専用シューティングゲームとして1996年にソフトベンダーTAKERUから発売され、MSX2 + 及びMSXturboR規格のビデオ性能（V9958）の限界に挑戦したその表現力が高く評価されました。<br>『MECHANICAL BRAIN ReHash』はゲームの世界観を引き継ぎつつも、最新のプログラム技術を駆使しゼロから作り直しました。Nintendo Switch™版は更にMSX2++専用版として追加改良をしております。",
      gametitle: "『MECHANICAL BRAIN ReHash』",
     // copyright: "©STARFISH-SD INC. Development and management by mebius.",
    },

    {
      imageUrl1: "re_TWF.png",
      title: "ロケットエンジン",
      linkUrl1: "http://studio-siesta.mails.ne.jp/index2.htm",
      //linkUrl2: "http://studio-siesta.mails.ne.jp/twf/index.html",
      text: "総勢13名以上のカワイイ魔女たちを操作し、どこかヌけている悪い魔女アマルガムの娘たちをやっつけよう！　ショップで買ったカードでパワーアップして敵の攻撃をアイテムに錬金！　大量ジャラジャラ感は脳汁どぱどぱしちゃう！",
      gametitle: "「トラブルウィッチーズふぁいなる！ラストエンド」",
     copyright: "©Rocket-Engine Co., Ltd. StudioSiestA",
    },
    {
      imageUrl1: "re_VAL.jpg",
      title: "ロケットエンジン",
      linkUrl1: "http://studio-siesta.mails.ne.jp/index2.htm",
      //linkUrl2: "http://studio-siesta.mails.ne.jp/twf/index.html",
      text: "遠い未来、謎の機械構造体の侵略から地球を救う為、遥か宇宙彼方にある『ヴァルシュトレイ宙域』を目指す！　ド派手で圧倒的な攻撃バリオンレーザーで敵の軍勢を一掃、さらには【無敵】になって敵に体当たり攻撃！　超！ハイスピード縦STG！<br>他にも謎のゲームがあるかも知れませんよ！？　各ソフトを試遊すると何か”いいもの”プレゼントしちゃいます！",
      gametitle: "「ヴァルシュトレイの狂颷」",
    // copyright: "©Rocket-Engine Co., Ltd. StudioSiestA",
    },
    // {
    //   imageUrl1: "petidepot.jpg",
    //   title: "プチデポット",
    //   //linkUrl1: "http://studio-siesta.mails.ne.jp/index2.htm",
    //   linkUrl2: "https://globule.info/gnosia/",
    //   text:
    //     "『グノーシア』はＳＦ世界を舞台にしたいわゆる人狼系ゲームを一人でも遊べるようにしたものです。１プレイは１５分程度で、周回するたびに、主人公及び各キャラクターの配役や展開が変化します。",
    //   gametitle: "グノーシア",
    //   copyright: "©2019-2024 Petit Depotto",
    // },
    // {
    //   imageUrl1: "kemco.jpg",
    //   title: "ケムコ",
    //   linkUrl1: "https://www.kemco.jp",
    //   linkUrl2: "https://www.kemco.jp/game/alphadia1-2/ja/",
    //   text:
    //     "シリーズ累計50万本突破のファンタジーRPG『アルファディア』シリーズ、始まりの二作を一本のゲームにしたリメイク版です。Ⅰ、Ⅱそれぞれご試遊いただけます。<br/>ドット絵コマンドバトルがお好きな方は是非遊びに来てくださいね！",
    //   gametitle: "アルファディアⅠ＆Ⅱ",
    //   copyright: "© 2004-2024 KEMCO",
    // },

    {
      imageUrl1: "RS34.jpg",
      title: "RS34",
      linkUrl1: "https://rs34.co.jp/index.html",
      //linkUrl2: "https://rs34.co.jp/game/illveloswamp/illveloswamp_index.html",
      text: "株式会社RS34は、『カラス』を展示します。<br>2006年に販売され好評を博したアーケード型シューティングゲーム、ヒトとの大戦で両親を失った少女、カラスは「神の血」を求めて地上を目指す。<br>RS34はシューティングゲームを中心にゲーム制作を続けています。<br>20年以上シューティングにこだわり、作り続けているのは、かなりレアな開発スタイルかもしれません。<br>独自性が強く、新しい体験ができるシューティングが特徴となります。",
      gametitle: "カラス",
    //  copyright: "©RS34.Published by mebius.",
    },

    // {
    //   imageUrl1: "OperaHouse2.jpg",
    //   title: "オペラハウス",
    //   linkUrl1: "https://www.opera-house.jp/",
    //   // linkUrl2: "http://d-mebius.com/toho_w_p/",
    //   text: "ゲーム展示＆対戦会<br/>対戦ゲームで勝った方に粗品をプレゼント",
    //   gametitle: "マッドストーカー X68000 Z",
    // },
    // {
    //   imageUrl1: "OperaHouse.jpg",
    //   title: "オペラハウス",
    //   linkUrl1: "https://www.opera-house.jp/",
    //   // linkUrl2: "http://d-mebius.com/toho_w_p/",
    //   text:
    //     "デモ展示「ラスグレイブ探偵譚」（MSXturboR、MSX2+、MSX0）「MECHANICAL BRAIN ReHash」（MSXturboR）「あすか120％ for X68000 Z」（X68000 Z）「MSX0 Stack」「MSX0 CARD」「MSXPLAYer」「MSXturboR」「X68000 Z」にてゲームのデモ展示を行います。<br/>あすか120％は対戦プレイ、MECHANICAL BRAINはα版をプレイして頂けます。その他、X68000 Z用に準備中のゲーム2～3タイトルをデモ展示します。",
    //   gametitle: "ラスグレイブ探偵譚 MSX",
    // },
    // {
    //   imageUrl1: "ThousandGames.jpg",
    //   title: "サウザンドゲームズ",
    //   linkUrl1: "https://www.thousandgames.net/",
    //   linkUrl2: "https://store.steampowered.com/app/1754460/QUESTER/",
    //   text:
    //     "『QUESTER』はハックアンドスラッシュに特化したダンジョン探索RPGです。漫画家・萩原一至が構築した退廃未来の世界観を元に、加藤ヒロノリがゲームデザインを行いました。",
    //   gametitle: "QUESTER",
    //   copyright: "©萩原一至・加藤ヒロノリ・Thousand Games ©Thousand Games",
    // },
    // {
    //   imageUrl1: "daisyworld.jpg",
    //   title: "デイジーワールド",
    //   linkUrl1: "https://www.daisyw0rld.com/",
    //   linkUrl2: "https://daisyw0rld.booth.pm/",
    //   text:
    //     "各社様ゲーム作品Tシャツ、トートバッグ、サコッシュの販売を行います<br/>会場特別価格品もございますので、是非ご覧になってくださいませ",
    //   gametitle: "物販",
    //   copyright: "",
    // },
    // {
    //   imageUrl1: "shanon.jpg",
    //   title: "シャノン",
    //   linkUrl1: "https://takiya.info/shannon/",
    //   //linkUrl2: "https://daisyw0rld.booth.pm/",
    //   text:
    //     "学園に潜む快楽殺人鬼集団の日常を描いた新作「アパシー殺人クラブ」の試遊ができます。恐ろしいサイコパスなのにどこか憎めない彼らの失敗続きのコミカルな作品となっています。また試遊していただいた方にポストカードを差し上げます。",
    //   gametitle: "アパシー殺人クラブ",
    //   copyright: "©飯島多紀哉",
    // },
    {
      imageUrl1: "cosmomachia.jpg",
      title: "コスモマキアー",
      //linkUrl1: "https://takiya.info/shannon/",
      linkUrl2: "https://shikigami3.cosmomachia.co.jp/",
      text:
        "ドラマチックシューティングの名作『式神の城Ⅲ』のSwitch版が、4月23日に発売となります！<br>Switch版ならではの、機能を多数搭載しております。<br>①ドラマティックチェンジモード搭載<br>②２人同時プレイ・おすそ分けプレイ対応<br>③ミュンヒハウゼン（隠しキャラクター）をデフォルトで選択可能<br>④縦画面プレイ対応<br>⑤インターネットランキング対応<br>Switch版『式神の城Ⅲ』の発売を記念して、歴代シリーズ3作品を収納したSwitch用ゲーム『式神の城トリロジー』の予約も受付中。各作品のサントラCDやガイドブックも封入された永久保存盤です。",
      gametitle: "式神の城Ⅲ",
     // copyright: "©飯島多紀哉",
    },
    {
      imageUrl1: "kimaira.jpg",
      title: "キマイラ機関",
      //linkUrl1: "https://takiya.info/shannon/",
      linkUrl2: "https://store.steampowered.com/app/4004490/_/?l=japanese",
      text:
        "ダンジョンを移動する主人公。<br/>主人公がダンジョン内で弾を撃つ。<br/>敵の弾を避ける。<br/>ＲＰＧだけどシューティングゲーム。<br/>けれども、ただのシューティングＲＰＧでは終わらないのが本作『宇宙銀河ウォーズ』。<br/>このゲーム体験は実際に遊んでみなきゃ絶対にわからない。<br/>ダンジョンを潜る。ＲＰＧではよくあることだ。<br/>ローグライク。うんうん。もちろん実装していますとも。<br/>ダンジョンの階層は……<br/>なんと１００万階！！<br/> （※嘘じゃありません）<br/>この狂ったＲＰＧをクリアするには正気ではいられない。<br/>当然、プレイヤーにも非常識な思考が求めれる。<br/>どうか己の中にあるＲＰＧの常識を破壊してほしい。<br/> 大切なのはアイデアだ。<br/>システムハックして１００万階を攻略せよ。<br/>本作は、ゲーマーたちへの挑戦状である。<br/>システム要件<br/>最低:<br/>OS: Windows7 64bit or later<br/>プロセッサー: Intel Core™ Duo or faster<br/>メモリー: 2 GB RAM<br/>グラフィック: Intel Integrated Graphics<br/>ストレージ: 2 GB の空き容量",
      gametitle: "『宇宙銀河ウォーズ』",
      //copyright: "©飯島多紀哉",
    },
    {
      imageUrl1: "cityconnection.png",
      title: "シティコネクション",
      //linkUrl1: "https://takiya.info/shannon/",
      linkUrl2: "https://city-connection.co.jp/fz/",
      text:"変形ロボシューティング『FZ：Formation Z』2026年5月21日（木）発売決定！<br>ジャレコの代表的タイトルのひとつ『フォーメーションZ』がフルリメイク！<br>人型ロボットと戦闘機形態を使い分けるゲーム性や操作感を引き継ぎつつ、グラフィックとサウンドを刷新。そして新たな武装や機体バリエーション、カスタマイズ要素等を追加！<br>今、戦慄のバトルフォーメーションが再び幕を開ける――！<br>対応プラットフォーム：Nintendo Switch 2、PlayStation 5、Xbox Series X| S、PC（Steam、Epic Games Store）",
    gametitle: "FZ：Formation Z",
      //copyright: "©飯島多紀哉",
    },
  ],
};
export default CompanyData;
